import type { CurrentUser } from "@duralex/shared";

/** The whole page for a viewer the server would refuse; `what` finishes "Admin access is required to ...". */
export function AdminOnlyCard({ user, what }: { user: CurrentUser | null; what: string }) {
  // A null user is an unconfirmed identity (the /me probe soft-passed),
  // not a known non-admin - the copy must not claim otherwise.
  return (
    <main className="cc-main">
      <div className="cc-body">
        <div className="cc-card" style={{ padding: "10px 18px", color: "var(--muted)" }}>
          {user
            ? `Admin access is required to ${what}.`
            : "Could not confirm your account. Refresh to retry."}
        </div>
      </div>
    </main>
  );
}
